<script setup>
import { useAlertBanner } from '../composables/AlertBanner.js'
import WarningBanner from '@/components/WarningBanner.vue'

const {
  warningBannerType,
  warningBannerMessage,
  warningBannerSeverity,
  warningBannerModal,
} = useAlertBanner();
</script>

<template>
  <WarningBanner :severity="warningBannerSeverity" :emphasize="warningBannerType == 'trayOpen'" :modal="warningBannerModal">
    <div class="w-full" v-if="warningBannerType == 'trayOpen'">
      <i class="fa fa-exclamation-triangle text-yellow-300 mr-2"></i> <span>{{ $t('catalog.tray_is_open') }}</span>
    </div>
    <div class="w-full" v-if="warningBannerType == 'weightMeasure'">
      <i class="fa fa-scale-balanced text-black dark:text-white mr-2"></i> <span>Tehtanje je obvezno!</span>
    </div>
    <div class="w-full" v-if="warningBannerType == 'custom'">
      <span v-if="warningBannerType">{{ warningBannerMessage }}</span>
    </div>
  </WarningBanner>
</template>